
import React, { useEffect, useState } from "react";
import { MeetingsContext } from "./meetingsContext";
import { getSectionPlanByStudent } from "services/MeetScheduling/getAll";

const MeetingsProvider = ({ children }) => {
  const [sectionPlanSpeaking, setSectionPlanSpeaking] = useState("");

  const getSectionPlanUser = async () => {
    const { data } = await getSectionPlanByStudent();
    setSectionPlanSpeaking(data);
  }

  useEffect(() => {
    getSectionPlanUser();
  }, []);

  return (
    <MeetingsContext.Provider
      value={{  sectionPlanSpeaking, getSectionPlanUser }}
    >
      {children}
    </MeetingsContext.Provider>
  );
};

export default MeetingsProvider;
